/**
 * The phone app's words for its Knowledge Base screens (piece 35, *The fourth
 * release*; decision 9580; row T3369), spread into the one string lookup beside
 * the earlier batches' words. A word the web's knowledge base already says, such
 * as Knowledge Base, Version, Published, No category or Comments, is read from
 * the web's own key and is not repeated here.
 */
export const KNOWLEDGE_PHONE_STRINGS = {
  'mobile.kb.none': 'No article is published yet.',
  'mobile.kb.loading': 'Reading the articles…',
  'mobile.kb.reading': 'Reading the article…',
  'mobile.kb.unpublished': 'This article has no published version to read yet.',
  'mobile.kb.picture': 'A picture in the article',
  // Decisions 11640, 11700: the reader's text size, chosen with no signal, is queued on the phone and sent when it has signal.
  'mobile.kb.textSizeHeld': 'Saved on this phone. Your text size reaches the web when the phone has signal.',
  'mobile.kb.textSizeUnsent': 'Your text size is not saved, because the server did not answer. Choose it again when the phone has signal.',
} as const;
